'use strict';

module Patersons {

    export class SelectionService {
        log: ng.ILogService;
        selectedAccountId: string;
        selectedWatchlistSecIds: string;

        static $inject = ['$log'];

        constructor($log) {
            this.log = $log;
        }

        getSelectedAccount(accounts: Array<Account>) : Account {
            if (accounts && accounts.length > 0) {
                var account = accounts.filter(x => x.accountId == this.selectedAccountId)[0];

                if (account == null) {
                    return accounts[0];
                }

                return account;
            }

            return null;
        }
    }
}
